import { IBitfApiCallState } from '@interfaces';
// tslint:disable-next-line:max-line-length
import { BitfPApiCallStateMapper } from '@bitf/core/api-call-state/bitf-p-api-call-state/bitf-p-api-call-state.mapper';

export class DefaultApiCallStateMapper extends BitfPApiCallStateMapper {
  buildApiRequest(apiCallState: IBitfApiCallState): void {
    super.buildApiRequest(apiCallState);
  }
}
